export function choseFilesIcon(val) {
    console.log(val);
    let getVal = val
    let msg = ''
    if (getVal.lastIndexOf('.') > -1) {
        msg = getVal.slice(getVal.lastIndexOf('.')+1)
    } else {
        msg = getVal
    };
    console.log(msg);
    switch (msg) {
        case 'docx' || 'doc':
            return 'doc'
            break;
        case 'jpg' || 'png' || 'gif':
            return 'img'
            break;
        case 'mp3':
            return 'mp3'
            break;
        case 'pdf':
            return 'pdf'
            break;
        case 'ppt':
            return 'ppt'
            break;
        case 'video':
            return 'video'
            break;
        case 'xls' || 'xlsx':
            return 'xlsx'
            break;
        default:
            return 'system_file'
    }
}